module.exports = __webpack_public_path__ + "media/images/filter-75f5bbb411ac47720294347173d0397f.svg";